import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function Footer() {
  const { bootstrap } = useStore();
  return (
    <footer className="border-t border-white/10 bg-[#0c0c0c] mt-24" data-testid="store-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/dragon-head.webp" alt="" className="h-14 w-auto drop-shadow-[0_0_16px_rgba(212,175,55,0.3)]" />
            <img src="/assets/wordmark.webp" alt="ZEFERIUS" className="h-8 w-auto" />
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
            Peças orientais autênticas. Cada compra confirmada gera um código de originalidade único vinculado ao seu nome.
          </p>
        </div>
        <div>
          <p className="label-caps mb-4">Navegação</p>
          <div className="flex flex-col gap-2.5">
            <Link to="/" className="text-sm text-zinc-400 hover:text-gold transition-colors">Início</Link>
            {(bootstrap?.categories || []).map((c) => (
              <Link key={c.id} to={`/categoria/${c.slug}`} className="text-sm text-zinc-400 hover:text-gold transition-colors">{c.name}</Link>
            ))}
          </div>
        </div>
        <div>
          <p className="label-caps mb-4">Confiança</p>
          <Link to="/autenticidade" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-gold transition-colors">
            <ShieldCheck size={15} className="text-gold" /> Verificar autenticidade
          </Link>
          <p className="text-xs text-zinc-600 mt-6">Pagamentos processados com segurança via InfinitePay.</p>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} {bootstrap?.settings?.store_name || "ZEFERIUS"}. Todos os direitos reservados.
      </div>
    </footer>
  );
}
